$('document').ready(function () {
    $('.js_courses-list-icon').on('click', function () {
        $(this).parents('.courses-list').find('.courses-list__body').slideToggle();
        $(this).toggleClass('courses-list__icon_state--close');
    });

    let $courses = $('.js_courses-list-line');

    $courses.each(function (index, element) {
        let $element         = $(element),
            nearestDatePrice = $element.find('.courses-list__date:first-child').data('price'),
            priceCurrency    = $element.find('.courses-list__date:first-child').data('currency'),
            nearestPrice     = 'Бесплатно';

        if (!!nearestDatePrice && Number.parseInt(nearestDatePrice) > 0) {
            nearestPrice = Number.parseInt(nearestDatePrice) + ' ' + priceCurrency;
        }

        $element.find('.courses-list__price').text(nearestPrice);
    });

    $('.js_courses-list-date', $courses).on('click', function () {
        let $this            = $(this),
            datePrice        = $this.data('price'),
            coursePrice      = 'Бесплатно',
            $courseListPrice = $this.parents('.js_courses-list-line').find('.courses-list__price');

        if (!!datePrice && Number.parseInt(datePrice) > 0) {
            coursePrice = Number.parseInt(datePrice) + ' ' + priceCurrency;
        }

        $courseListPrice.fadeOut(function () {
            $courseListPrice.text(coursePrice);
        });
        $courseListPrice.fadeIn();
    });
});